import { Link } from 'react-router-dom'
import { useLanguage } from '@afsa/shared'

export const LogoSection = () => {
  const { t } = useLanguage()

  return (
    <div className="md:flex items-center gap-4">
      <div className="flex-shrink-0">
        <Link to="/">
          <img
            className="h-16 w-26 cursor-pointer"
            src="https://res.cloudinary.com/dlwegkhme/image/upload/v1755760984/LOGO_AFSA_o4r8px.png"
            alt="AFSA logo"
          />
        </Link>
      </div>

      <div className="sm:max-w-sm lg:max-w-lg">
        <p className="text-gray-100 text-base font-semibold md:font-normal font-satoshi leading-normal">
          {t('harnessing_space_tech')}
        </p>
      </div>
    </div>
  )
}